import { Helmet } from "react-helmet";
import { Text } from "../Type";
import Button from "../Button";

import styles from "./index.module.scss";

const AppErrorBoundary = () => {
  const refreshPage = () => {
    window.location.reload();
  };
  return (
    <div className={styles.content}>
      <Helmet>
        <title>Oops, Something went wrong</title>
      </Helmet>
      <Text className={styles.text} size="xlarge" weight="bold">
        Oops, Something went wrong
      </Text>
      <Text>
        Sorry, we are experencing an internal server problem.
        <Text>Please try again later.</Text>
      </Text>
      <div className={styles.button}>
        <Button primary onClick={refreshPage}>
          Refresh page
        </Button>
      </div>
    </div>
  );
};

export default AppErrorBoundary;
